<template>
  <div class="w-[40%] white-background bg-white dark:bg-slate-900">
    <div class="flex-end mb-4">
      <select v-model="filter" @change="onFilterChange" class="select">
        <option value="today">{{ $t('PAYMENTS.TODAY') }}</option>
        <option value="week">{{ $t('PAYMENTS.LAST_WEEK') }}</option>
        <option value="month">{{ $t('PAYMENTS.LAST_MONTH') }}</option>
        <option value="custom">{{ $t('PAYMENTS.CUSTOM') }}</option>
      </select>

      <!-- <div v-if="filter === 'custom'" class="mt-2 flex gap-2">
        <input type="date" v-model="customStart" class="input" />
        <input type="date" v-model="customEnd" class="input" />
      </div> -->
    </div>
    <div v-if="filter === 'custom'" class="mt-2 flex-end gap-2">
      <div class="date-picker">
        <date-picker
          :range="true"
          :confirm="true"
          :clearable="false"
          :editable="false"
          :confirm-text="confirmText"
          :placeholder="placeholder"
          :value="value"
          @change="handleChange"
          v-model="selectedDate"
        />
      </div>
    </div>
    <div v-if="!uiFlags.isFetchingItem">
      <apexchart
        type="line"
        height="300"
        :options="chartOptions"
        :series="chartSeries"
      />
    </div>
    <div class="fixed-height" v-else-if="uiFlags.isFetchingItem">
      <loading-state
        v-if="uiFlags.isFetchingItem"
        :message="emptyStateMessage"
      />
    </div>
  </div>
</template>
  
  <script>
import ApexChart from 'vue-apexcharts';
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
import LoadingState from 'dashboard/components/widgets/LoadingState';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import DatePicker from 'vue2-datepicker';

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

export default {
  name: 'ChartWithFilter',
  components: {
    apexchart: ApexChart,
    LoadingState,
    DatePicker,
  },
  props: {
    payments: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      filter: 'today',
      customStart: '',
      customEnd: '',
      emptyStateMessage: 'Loading Graph',
      selectedDate: null,
      confirmText: 'Select Date Range',
      placeholder: 'Select date range',
    };
  },
  mounted() {
    this.$store.dispatch('payments/GraphView');
  },
  computed: {
    ...mapGetters({
      uiFlags: 'payments/getUIFlags',
    }),
    graphData() {
      const data = this.$store.getters['payments/graphData'];
      console.log('My Status Data', data);

      // this.$emit('payments-fetched', data); // 👈 emit event to parent
      return data.data;
    },
    filteredData() {
      const now = dayjs();
      let start, end;

      if (this.filter === 'today') {
        start = now.startOf('day');
        end = now.endOf('day');
      } else if (this.filter === 'week') {
        start = now.startOf('week');
        end = now.endOf('week');
      } else if (this.filter === 'month') {
        start = now.startOf('month');
        end = now.endOf('month');
      } else if (this.filter === 'custom') {
        if (!this.selectedDate || this.selectedDate.length !== 2) return [];
        start = dayjs(this.selectedDate[0]);
        end = dayjs(this.selectedDate[1]);
      }

      return this.graphData.filter(entry => {
        const date = dayjs(entry.date);
        return (
          date.isSameOrAfter(start, 'day') && date.isSameOrBefore(end, 'day')
        );
      });
    },
    chartSeries() {
      return [
        {
          name: 'Amount',
          data: this.filteredData.map(entry => Number(entry.value)),
        },
      ];
    },
    chartOptions() {
      return {
        chart: {
          id: 'filtered-line-chart',
        },
        xaxis: {
          categories: this.filteredData.map(entry => entry.date),
        },
        title: {
          // text: `${this.filter}`,
          // align: 'left',
          text: `${this.filter}`,
          align: 'left',
          offsetY: 0, // 👈 Move title to top (0px from top)
          style: {
            fontSize: '16px',
            fontWeight: 'bold',
          },
        },
        stroke: {
          curve: 'smooth',
        },
      };
    },
  },
  methods: {
    setFilter(type) {
      this.filter = type;
    },
    async graphvalue(formattedStart, formattedEnd) {
      const payload = {
        start_date: formattedStart || null,
        end_date: formattedEnd || null,
      };
      console.log('API Payload:', payload);
      await this.$store.dispatch('payments/GraphView', payload);
    },
    onFilterChange() {
      const today = new Date();
      let startDate, endDate;

      if (this.filter === 'today') {
        startDate = endDate = today;
      } else if (this.filter === 'week') {
        endDate = today;
        startDate = new Date();
        startDate.setDate(today.getDate() - 6); // last 7 days including today
      } else if (this.filter === 'month') {
        endDate = today;
        startDate = new Date();
        startDate.setMonth(today.getMonth() - 1);
      }

      // Format as DD/MM/YYYY or ISO as needed
      const formatDate = date => {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
      };

      const formattedStart = formatDate(startDate);
      const formattedEnd = formatDate(endDate);

      console.log('Start Date:', formattedStart);
      console.log('End Date:', formattedEnd);
      this.graphvalue(formattedStart, formattedEnd);
      // Now you can dispatch an action or call an API with these dates
      // this.filterData({ start_date: formattedStart, end_date: formattedEnd });
    },
    handleChange(dates) {
      if (!dates || dates.length !== 2) return;

      const formatDate = date => {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
      };

      const formattedStart = formatDate(dates[0]);
      const formattedEnd = formatDate(dates[1]);

      console.log('Start Date:', formattedStart);
      console.log('End Date:', formattedEnd);

      this.graphvalue(formattedStart, formattedEnd);
    },
  },
};
</script>
  
  <style scoped>
.btn {
  background: #3b82f6;
  color: white;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
}
.btn:hover {
  background: #2563eb;
}
.input {
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.white-background {
  /* background-color: #fff; */
  border-radius: 5px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  padding: 15px 10px;
  border: 1px solid;
}
.select {
  width: 23%;
}
.fixed-height {
  height: 300px;
}
</style>
  